<template>
    <div class="c-step__head">
        <slot name="heading"/>
    </div>
    <!-- /.c-step__head -->
</template>

<script>
    export default {};
</script>

<style lang="scss">
    .c-step {
        &__head {
            position: relative;
            max-width: 100%;
            display: flex;
            align-items: center;
            margin-bottom: 2.8125rem;
            font-family: "Montserrat", sans-serif;

            &:before {
                content: "";
                position: absolute;
                width: 100%;
                top: 0;
                bottom: 0;
                right: 100%;
                background-color: #f98155;
            }

            h3 {
                color: #fff;
                background-color: #f98155;
                font-size: 1.7rem;
                font-weight: 400;
                margin: 0;
                padding: 0.31rem 0.937rem 0.31rem 16.5625rem;
                min-width: 35.625rem;
                text-align: right;
            }

            span {
                color: black;
                background-color: #fdfdfd;
                padding-left: 0.9375rem;
                padding-bottom: 0.125rem;
                letter-spacing: 0.01rem;
                font-size: 1.2rem;
                font-family: "Roboto", sans-serif;
                font-weight: 500;
            }
        }

        &__body {
            max-width: 100%;
        }

        @media screen and (max-width: 1024px) {
            &__head {
                margin-bottom: 1.25rem;

                h3 {
                    padding-left: 6.25rem;
                    min-width: 31.25rem;
                    font-size: 1.5rem;
                }
            }
        }

        @media screen and (max-width: 767px) {
            &__head {
                h3 {
                    padding-left: 0;
                    min-width: 15.75rem;
                    font-size: 1.2rem;
                }
            }
        }
    }
</style>
